import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../queryKeys';

import { fetchEntitledChannels } from './queryFunctions';

export function useEntitledChannels() {
  const { data, error } = useQuery({
    queryKey: queryKeys.entitledChannels,
    queryFn: () => fetchEntitledChannels(),
    staleTime: Infinity,
  });

  return {
    entitledChannels: data,
    error,
  };
}
